/*
 * @Author: wuzhonghai1 wuzhonghai1@jd.com
 * @Date: 2024-07-24 20:26:37
 * @LastEditors: weiyanna weiyanna@jd.com
 * @LastEditTime: 2026-06-17 13:13:18
 * @FilePath: /isp_International/src/util/init.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

export const setVnStyle = function(){
  if (localStorage.getItem('_language') == 'vi') {
   
    document.body.classList.add('vi-container')
  }
}